import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/firestore'
import 'firebase/performance'

// @ts-ignore
import firebaseConfig from '../../firebaseConfig.js'

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

const auth = firebase.auth
const analytics = firebase.analytics
const firestore = firebase.firestore
const performance = firebase.performance

analytics()
performance()

export { auth, analytics, firestore, performance }
